import React from 'react';
import RulesSelector from './comp/rulesSelector/RulesSelectorConnector';
import RulesOrder from './comp/rulesOrder/RulesOrderConnector';
import './profileRulesManagement.scss';

class ProfileRulesManagement extends React.Component {
  render() {
    return (
      <div className="profile-rules-management">
        <RulesSelector />
        <RulesOrder />
      </div>
    );
  }
}

export default ProfileRulesManagement;



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/rulesPanel/comp/profileRulesManagement/ProfileRulesManagement.js